module.exports = __webpack_public_path__ + "img/rutas-bg.5b73267c.jpg";